import React, {FC, memo} from "react";
import classnames from "classnames";
import css from "./SectionHeader.less";

type SectionHeaderProps = {
    level?: 1 | 2 | 3 | 4;
    size?: "default" | "small" | "medium";
    text?: string | React.ReactNode;
    subText?: string | React.ReactNode;
    extra?: string | React.ReactNode;
    inlineContent?: React.ReactNode;
    style?: React.CSSProperties;
};

const SectionHeader: FC<SectionHeaderProps> = ({
    level = 1,
    text = "",
    subText = "",
    inlineContent,
    extra,
    style,
    size = "default",
}) => {
    const Tag = `h${level}`;

    const actualStyle = extra
        ? {...style, display: "flex", justifyContent: "space-between"}
        : style;

    const header = (
        <Tag
            className={classnames([
                css.header,
                css.root,
                {
                    [css.small]: size === "small",
                },
                {[css.medium]: size === "medium"},
            ])}
            style={actualStyle}
        >
            <div>
                {text}
                {subText}
            </div>
            <div>{extra}</div>
        </Tag>
    );

    if (inlineContent === undefined) {
        return header;
    }

    return (
        <div
            className={classnames([
                css.root,
                {
                    [css.small]: size === "small",
                    [css.medium]: size === "medium",
                },
            ])}
        >
            <div className={css.headerWrapper}>
                <Tag className={css.header} style={style}>
                    {text}
                </Tag>
                <Tag className={css.subHeader} style={style}>
                    {subText}
                </Tag>
            </div>
            {inlineContent}
        </div>
    );
};

export default memo(SectionHeader);
